const categories = [
  {
    type: 'item',
    key: 'Posts',
    title: 'Bài đăng',
    icon: 'form',
    adminOnly: false,
    allowSupervisor: true,
  },
  {
    type: 'item',
    key: 'Pages',
    title: 'Trang nội dung',
    icon: 'appstore-o',
    adminOnly: false,
    allowSupervisor: true,
  },
{
    type: 'item',
    key: 'Profile',
    title: 'Hồ sơ cá nhân',
    icon: 'user',
    adminOnly: false,
  },  
/*  {
    type: 'item',
    key: 'Videos',
    title: 'Videos',
    icon: 'youtube',
    adminOnly: true,
    allowSupervisor: true,
  },
*/  
  {
    type: 'sub-menu',
    key: 'Management',
    title: 'Quản trị',
    icon: 'setting',
    adminOnly: true,
    allowSupervisor: true,
    items: [
      {
        type: 'item',
        key: 'HomePage',
        title: 'Trang chủ',
        icon: 'home',
        adminOnly: true,
        allowSupervisor: true,
      },
      {
        type: 'item',
        key: 'Menu',
        title: 'Trình đơn',
        icon: 'menu-unfold',
        adminOnly: true,
        allowSupervisor: true,
      },
      {
        type: 'item',
        key: 'Categories',
        title: 'Danh mục',
        icon: 'bars',
        adminOnly: true,
        allowSupervisor: true,        
      },
      {
        type: 'item',
        key: 'Users',
        title: 'Tài khoản',
        icon: 'team',
        adminOnly: true,
        allowSupervisor: false,
      },
    ],
  },
];

export {
categories,
};


// WEBPACK FOOTER //
// ./src/screens/Dashboard/Categories/items.js